<template>
  <div class="content">
    <el-tabs class="tabs" v-model="activeName" type="card" @tab-click="handleClick" style="width: 100%;">
      <el-tab-pane label="本科院校" name="first">
        <filter1 @clickone='clickone' @clickAll='clickAll'></filter1>
        <div class="left">
          <!-- 搜索 -->
          <div style="margin-top: 15px;width: 547px;">
            <el-input placeholder="请输入内容" v-model="keyword">
              <el-button slot="append" icon="el-icon-search" @click="search()">搜索</el-button>
            </el-input>
          </div>
          <!-- 学校列表 -->
          <div class="schoolList">
            <div class="one flex" @click="goDetail(item)" v-for="(item,index) in data">
              <img :src='"https://yunzhixuanpro.fw366.cn/"+item.badge_img'>
              <div class="info" style="width: 400px;">
                <div>
                  <span class="name">{{item.school_name}}</span>
                </div>
                <div class="address">
                  <span>{{item.province_name}}-{{item.city_name}}</span>
                </div>
                <div class="type">
                  <span>{{item.type}}</span>
                  <span>|</span>
                  <span>{{item.edu_zn}}</span>
                  <span>|</span>
                  <span>{{item.cate_zn}}</span>
                  <span v-if="item.is_211">
                    <span>|</span>{{item.is_211==1?'211':''}}
                  </span>
                  <span v-if="item.is_985">
                    <span>|</span>{{item.is_985==1?'985':''}}
                  </span>
                  <span v-if="item.is_double==1">
                    <span>|</span>双一流
                  </span>
                  <span v-if="item.management">
                    <span>|</span>所属部门：{{item.management}}
                  </span>
                  <!-- <span v-if="item.school_rank!=''">
                    <span>|</span>院校排名<span style="color: orange;">{{item.school_rank}}</span>
                  </span> -->
                </div>
              </div>
              <div class="info1">
                <div>星级</div>
                <div class="star"><img v-for="(item1,index1) in item.rank" src="../../assets/school/star.png"></div>
              </div>
              <button type="button" @click="goDetail(item)">查看详情</button>
            </div>

          </div>
          <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="tiaojian.page"
            style="margin-top: 60px;" @current-change="current_change" v-if="pageshow">
          </el-pagination>
        </div>

        <div class="right">
          <sidebar></sidebar>
        </div>

      </el-tab-pane>
      <el-tab-pane label="专科院校" name="second" @tab-click="handleClick">
        <filter1 @clickone='clickone' @clickAll='clickAll'></filter1>
        <div class="left">
          <!-- 搜索 -->
          <div style="margin-top: 15px;width: 547px;">
            <el-input placeholder="请输入内容" v-model="keyword">
              <el-button slot="append" icon="el-icon-search" @click="search()">搜索</el-button>
            </el-input>
          </div>
          <!-- 学校列表 -->
          <div class="schoolList">
            <div class="one flex" @click="goDetail(item)" v-for="(item,index) in data">
              <img :src='"https://yunzhixuanpro.fw366.cn/"+item.badge_img'>
              <div class="info">
                <div style="width: 400px;">
                  <span class="name">{{item.school_name}}</span><span class="address">{{item.province_name}}</span>
                </div>
                <div class="type">
                  <span>{{item.type}}</span>
                  <span>|</span>
                  <span>{{item.cate_zn}}</span>
                </div>
              </div>
              <div class="info1">
                <div>星级</div>
                <div class="star"><img src="../../assets/school/star.png"><img src="../../assets/school/star.png"><img
                    src="../../assets/school/star.png"><img src="../../assets/school/star.png"></div>
              </div>
              <button type="button" @click="goDetail(item)">查看详情</button>
            </div>

          </div>
          <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="tiaojian.page"
            style="margin-top: 60px;" @current-change="current_change" v-if="pageshow">
          </el-pagination>
        </div>

        <div class="right">
          <sidebar></sidebar>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import sidebar from '../../components/sidebar.vue'
  import filter1 from '../../components/filter.vue'
  export default {
    data() {
      return {
        activeName: 'first',
        pageshow: true,
        data: [],
        data1: [],
        keyword: '',
        page: 4,
        total: null,
        tiaojian: {
          page: 1,
          keyword: '',
          category_id: [],
          levels: [],
          province_id: [],
          type: [],
          edu: null
        }
      }
    },
    created() {
      console.log(this.$route.query.name)
      if (this.$route.query.name != '' && this.$route.query.name != undefined) {
        this.$http.schoolSearch({
          name: this.$route.query.name
        }).then(res => {
          this.data = res.data.list
          this.total = res.data.count
        })

      } else {
        this.$http.schoolList().then(res => {
          this.data = res.data.list
          this.total = res.data.count
        })
        // this.$http.schoolList({
        //   province_id: 19,
        //   edu: 2
        // }).then(res => {
        //   this.data1 = res.data.list
        //   this.total1 = res.data.count
        // })
      }
    },
    components: {
      sidebar,
      filter1
    },
    methods: {
      handleClick(e) {
        if (e.label == '专科院校') {
          this.tiaojian.edu = 2
          this.$http.schoolList({
            province_id: 19,
            edu: 2
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
          })
        } else {
          this.tiaojian.edu = 1
          this.$http.schoolList().then(res => {
            this.data = res.data.list
            this.total = res.data.count
          })
        }
      },
      clickAll(e) {
        if (this.activeName == 'second') {
          this.tiaojian.edu = 2
        }
        this.tiaojian.page = 1
        this.tiaojian.province_id = e.province_id
        this.$http.schoolList(e).then(res => {
          this.data = res.data.list
          this.pageshow = false; //让分页隐藏
          this.$nextTick(() => { //重新渲染分页
            this.pageshow = true;
          });
        })
      },
      current_change(e) {
        this.tiaojian.page = e
        if (this.activeName == 'second') {
          this.tiaojian.edu = 2
        }
        if (this.keyword != '') {
          this.$http.schoolSearch({
            name: this.keyword,
            page: e
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
          })
        } else {
          this.$http.schoolList(this.tiaojian).then(res => {
            console.log(res)
            this.data = res.data.list
            this.total = res.data.count
            this.pageshow = false; //让分页隐藏
            this.$nextTick(() => { //重新渲染分页
              this.pageshow = true;
            });
          })
        }
      },
      clickone(e) {
        if (this.activeName == 'second') {
          this.tiaojian.edu = 2
        }
        this.tiaojian.page = 1
        this.tiaojian.province_id = e.province_id
        this.tiaojian.levels = e.levels
        this.tiaojian.type = e.type
        this.tiaojian.category_id = e.category_id
        console.log(this.tiaojian)
        this.$http.schoolList(this.tiaojian).then(res => {
          this.data = res.data.list
          this.total = res.data.count
          this.pageshow = false; //让分页隐藏
          this.$nextTick(() => { //重新渲染分页
            this.pageshow = true;
          });
        })
      },
      goDetail(item) {
        this.$router.push('/schoolDetail?id=' + item.id)
      },
      search() {
        console.log(1)
        this.$http.schoolSearch({
          name: this.keyword
        }).then(res => {
          this.data = res.data.list
          this.total = res.data.count
        })
      }
    }
  }
</script>

<style lang="scss" scoped="scoped">
  .remen {
    .more {
      display: inline-block;
      float: right;
    }

    .right {
      width: 300px;
      float: left;
      margin-top: 33px;
      margin-left: 40px;
    }

    .block {
      margin: 51px 0 0 26px;
    }

    .left {
      margin-top: 31px;
      width: 855px;
      float: left;
    }

    .title {
      width: 100px;
      position: relative;
      line-height: 18px;
    }

    .title1 {
      margin-top: 42px;
      position: relative;
      line-height: 18px;
      justify-content: space-between;
    }

    .title::before {
      content: "";
      width: 4px;
      height: 18px;
      position: absolute;
      top: 0;
      left: 0;
      background: #C10B17;
    }

    .title1::before {
      content: "";
      width: 4px;
      height: 18px;
      position: absolute;
      top: 0;
      left: 0;
      background: #C10B17;
    }

    ul {
      margin-top: 30px;
    }

    li {
      width: 100%;
      margin-bottom: 23px;
      text-align: left;
      line-height: 34px;
      display: flex;
      align-items: center;
    }

    .hot {
      color: #FFA200;
      margin-left: 120px;
    }

    .rank {
      width: 28px;
      height: 34px;
      background: url(../../assets/school/1.png);
      display: inline-block;
      color: #FFFFFF;
      line-height: 34px;
      text-align: center;
      margin-right: 17px;
    }

    .rank1 {
      background: url(../../assets/school/2.png);
    }

    .rank2 {
      background: url(../../assets/school/3.png);
    }

    .rank3 {
      background: #F2F2F2;
    }
  }

  .right {
    position: absolute;
    right: 0px;
    top: 0;

    .guanggao {
      img {
        display: block;
      }
    }
  }

  .left {
    position: relative;
  }


  .schoolList {
    margin: 40px 0;

    .one {
      .info {
        margin: 0 30px;
      }

      cursor: pointer;

      .info1 {
        width: 270px;

        img {
          width: 20px;
          height: 20px;
          margin-top: 16px;
        }
      }

      text-align: left;
      border-bottom: 1px solid #F2F2F2;
      padding-bottom: 37px;
      margin-top: 30px;

      button {
        width: 74px;
        height: 32px;
        background: #C10B17;
        border-radius: 4px;
        border: none;
        font-weight: 400;
        color: #FFFFFF;

      }

      img {
        width: 67px;
        height: 67px;
        border-radius: 50%;
        margin-right: 12px;
      }

      .type {
        margin-top: 22px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;

        span {
          margin-right: 5px;
        }
      }

      .name {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-right: 29px;
        margin-bottom: 10px;
      }

      .address {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        margin-top: 10px;
      }
    }
  }

  .list {
    margin-left: 40px;
    width: 800px;
    /* justify-content: space-between; */
  }

  .list span {
    margin: 0px 26px 28px 0px;
  }

  .active {
    color: #C10B17;
  }

  .content {
    max-width: 1280px;
    margin: 20px auto;
  }

  .left {
    width: 70%;
  }
</style>
<style lang="scss">
  .tabs .el-tabs__nav-wrap {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/view/school/schoolList.vue